import styled from "styled-components";

export const WalletLogsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
`;

export const WalletLogsRowBorder = styled.div`
  width: 100%;
  height: 3px;
  background: var(--Black-100, #f0f0f0);
`;

export const WalletLogsListRow = styled.div`
  padding: 10px 16px;
  display: flex;
  align-items: flex-start;
  gap: 21px;
`;

export const WalletLogListDate = styled.div`
  width: 30px;
  font-weight: 500;
  font-size: 11px;
  color: var(--Black-500, #202020);
`;

export const WalletLogsListItem = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  > .point {
    display: flex;
    gap: 3px;
    font-weight: 600;
    font-size: 13px;
    color: #121212;
  }
`;

export const WalletLogsListItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  > .info {
    font-weight: 600;
    font-size: 13px;
    color: #121212;
  }

  > .date {
    font-weight: 400;
    font-size: 11px;
    color: #808080;
  }
`;

export const WalletLogsListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;
